import { isEmpty } from 'lodash'
import { atom, computed } from 'nanostores'
import { type Layer } from './product-customization-board.utils'

export const $selectedVariantId = atom<string>('')

export const $isCustomizationActive = atom(false)

export const $virtualLayersEl = atom<HTMLElement | null>(null)

export const $inputVariantLayers = atom<Record<string, string>>({})
export const $initialLayerColors = atom<Record<string, string>>({})
export const $inputLayersUrl = computed(
  [$selectedVariantId, $inputVariantLayers],
  (selectedVariantId, inputVariantLayers) => {
    if (!selectedVariantId) return ''

    return inputVariantLayers[selectedVariantId] ?? ''
  }
)

export const $outputLayers = atom<Layer[]>([])

export const $previewDataUri = atom('')
export const $previewResolutionWidth = atom(1472)
export const $previewWatermarkImageUrl = atom('')
export const $previewWatermarkHelpText = atom('')

export const $printSimulationHelpText = atom('')
export const $printSimulationWarnText = atom('')
export const $printSimulationErrorText = atom('')
export const $printSimulationDataUri = atom('')
export const $printSimulationError = atom('')
export const $printSimulationAbortController = atom<AbortController | undefined>()
export const $isPrintSimulationLoading = atom(false)
export const $isPrintSimulationMatchPreview = atom(true)
export const $isPrintSimulationLoaded = computed(
  $printSimulationDataUri,
  (printSimulationDataUri) => !isEmpty(printSimulationDataUri)
)

export const $reviewConfirmationMessage = atom('')
export const $reviewConfirmationAgreed = atom(false)

export const reset = () => {
  $selectedVariantId.set('')
  $isCustomizationActive.set(true)
  $virtualLayersEl.set(null)
  $inputVariantLayers.set({})
  $initialLayerColors.set({})
  $outputLayers.set([])
  $previewDataUri.set('')
  $previewResolutionWidth.set(1472)
  $previewWatermarkImageUrl.set('')
  $previewWatermarkHelpText.set('')
  $printSimulationHelpText.set('')
  $printSimulationWarnText.set('')
  $printSimulationErrorText.set('')
  $printSimulationDataUri.set('')
  $printSimulationError.set('')
  $printSimulationAbortController.set(undefined)
  $isPrintSimulationLoading.set(false)
  $isPrintSimulationMatchPreview.set(true)
  $reviewConfirmationMessage.set('')
  $reviewConfirmationAgreed.set(false)
}
